// Share Journal navigation, progress, visibility timing and seamless-loop behavior.
customElements.whenDefined('brand-journal-showcase').then(() => {
  if (customElements.get('brand-stories-showcase')) return;
  class BrandStoriesShowcase extends customElements.get('brand-journal-showcase') {
    get carouselName() { return 'stories'; }
    get itemLabel() { return 'story'; }

    connectedCallback() {
      super.connectedCallback();
      if (this.videoDialogInitialized) return;

      this.videoDialog = this.querySelector('[data-stories-video-dialog]');
      this.videoMedia = this.videoDialog?.querySelector('[data-stories-video-media]');
      this.videoCloseButton = this.videoDialog?.querySelector('[data-stories-video-close]');
      if (!this.videoDialog || !this.videoMedia || !this.videoCloseButton) return;

      this.videoDialogInitialized = true;
      this.handleVideoOpen = (event) => {
        const trigger = event.target.closest('[data-stories-video-open]');
        if (!trigger || !this.contains(trigger)) return;
        const templateId = trigger.dataset.storiesVideoOpen;
        const template = templateId ? this.querySelector(`#${CSS.escape(templateId)}`) : null;
        if (!(template instanceof HTMLTemplateElement)) return;

        this.lastVideoTrigger = trigger;
        this.videoMedia.replaceChildren(template.content.cloneNode(true));
        this.savedDocumentOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.videoDialog.showModal();
        const video = this.videoMedia.querySelector('video');
        if (video) video.controls = !this.mobile.matches;
        if (this.mobile.matches) {
          video?.pause();
          if (video) video.currentTime = 0;
        } else {
          video?.play().catch(() => {});
        }
      };
      this.handleFullscreenVideo = (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        const trigger = event.target.closest('[data-stories-video-fullscreen]');
        if (!trigger || !this.videoMedia.contains(trigger) || !this.mobile.matches) return;
        if (event.type === 'keydown') event.preventDefault();
        const video = trigger.querySelector('video');
        if (!video) return;
        if (typeof video.webkitEnterFullscreen === 'function') {
          video.webkitEnterFullscreen();
        } else if (typeof video.requestFullscreen === 'function') {
          video.requestFullscreen().catch(() => {});
        }
        video.play().catch(() => {});
      };
      this.closeVideo = () => {
        if (this.videoDialog.open) this.videoDialog.close();
      };
      this.handleDialogClick = (event) => {
        if (event.target === this.videoDialog) this.closeVideo();
      };
      this.handleDialogClose = () => {
        const video = this.videoMedia.querySelector('video');
        video?.pause();
        this.videoMedia.replaceChildren();
        document.documentElement.style.overflow = this.savedDocumentOverflow || '';
        this.lastVideoTrigger?.focus({ preventScroll: true });
        this.lastVideoTrigger = null;
      };

      this.addEventListener('click', this.handleVideoOpen);
      this.videoMedia.addEventListener('click', this.handleFullscreenVideo);
      this.videoMedia.addEventListener('keydown', this.handleFullscreenVideo);
      this.videoCloseButton.addEventListener('click', this.closeVideo);
      this.videoDialog.addEventListener('click', this.handleDialogClick);
      this.videoDialog.addEventListener('close', this.handleDialogClose);
    }

    disconnectedCallback() {
      if (this.videoDialogInitialized) {
        this.removeEventListener('click', this.handleVideoOpen);
        this.videoMedia?.removeEventListener('click', this.handleFullscreenVideo);
        this.videoMedia?.removeEventListener('keydown', this.handleFullscreenVideo);
        this.videoCloseButton?.removeEventListener('click', this.closeVideo);
        this.videoDialog?.removeEventListener('click', this.handleDialogClick);
        this.videoDialog?.removeEventListener('close', this.handleDialogClose);
        const video = this.videoMedia?.querySelector('video');
        video?.pause();
        this.videoMedia?.replaceChildren();
        if (this.videoDialog?.open) this.videoDialog.close();
        document.documentElement.style.overflow = this.savedDocumentOverflow || '';
        this.videoDialogInitialized = false;
      }
      super.disconnectedCallback();
    }

    updateLayout() {
      if (this.mobile.matches) {
        super.updateLayout();
        return;
      }
      this.finishLoop();
      this.track.style.removeProperty('padding-right');
      this.track.style.removeProperty('scroll-padding-right');
      this.updateNavigation();
    }
  }
  customElements.define('brand-stories-showcase', BrandStoriesShowcase);
});
